class JobsFloatingMenu {
  constructor(showThreshold) {
    this.isFloatingMenuHidden = false; // ×を選択したらtrue
    this.isConditionSet = false; // ×を選択したらtrue
    this.showThreshold = showThreshold;
    this.bindEvents();
    this.scrollEvent();
    this.inputEvent();
  }

  scrollEvent() {
    // 非ログイン時のみ
    if ($('#signed_in').val() === 'false') {
      $(window).on('scroll', () => {
        if (
          $(window).scrollTop() >= this.showThreshold &&
          !this.isFloatingMenuHidden
        ) {
          $('.c-floating-menu__js, .js-back-to-top').fadeIn(100);
        } else {
          $('.js-back-to-top').fadeOut(100);
          if (this.isConditionSet !== true) {
            $('.c-floating-menu__js').fadeOut(100);
          }
        }
      });
    } else {
      $(window).on('scroll', () => {
        if ($(window).scrollTop() >= this.showThreshold) {
          $('.js-back-to-top').fadeIn(100);
        } else {
          $('.js-back-to-top').fadeOut(100);
        }
      });
    }
  }

  inputEvent() {
    // チェックボックスを選択した場合
    $('.p-side-search-form input[type="checkbox"]').on('click', () => {
      this.addSearchButtons();
    });

    // フリーワードを入力した場合
    $('.p-side-search-form input[type="text"]').on('input', () => {
      this.addSearchButtons();
    });

    // 希望年収（セレクトボックス）を選択した場合
    $('.p-side-search-form select').on('change', () => {
      this.addSearchButtons();
    });

    // "検索条件をクリア"を押下した場合
    $('#js-form-reset').on('click', () => {
      this.addSearchButtons();
    });
  }

  addSearchButtons() {
    if (!this.isFloatingMenuHidden) {
      $('.c-floating-menu__js').fadeIn(100);
      $('.c-floating-menu__apply').fadeOut(100);
      $('.c-floating-menu__to-pc-search').addClass('u-flex');
      this.isConditionSet = true;
    }
  }

  bindEvents() {
    // scroll back to top
    $('.js-back-to-top').on('click', () => {
      $('body, html').animate({ scrollTop: 0 }, 500);
    });
    // close button on floating menu
    $('.c-floating-menu__js  .btn-close').on('click', () => {
      $('.c-floating-menu__js').hide();
      this.isFloatingMenuHidden = true;
    });
  }
}

export default JobsFloatingMenu;
